<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <el-form ref="form" :model="dioForm" :rules="rules" label-width="160px">
            <el-form-item :label="$t('public.table_scope')" prop="scopeText"
                v-if="$store.state.type === 3 || $store.state.type === 2">
                <span>{{ dioForm.scopeText }}</span>
            </el-form-item>
            <el-form-item :label="$t('public.table_arch')" prop="structureText">
                <el-select style="width:250px" v-model="dioForm.structureText" popper-class="Architecture">
                    <el-option :value="dioForm.structureText">
                        <div class="treeClass">
                            <trees @changeNode="nodeClick" :treedata="dataTree" ref="tree" />
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item :label="$t('integration.label_carrier_name')" prop="keycode">
                <el-input v-model.trim="dioForm.keycode" style="width: 250px"></el-input>
            </el-form-item>
            <el-form-item :label="$t('integration.label_carrier_status')" prop="status">
                <el-select  v-model="dioForm.status" style="width: 250px">
                    <el-option v-for="item in getCarrierStatus" :key="item.code"
                         :label="getLanguage() === 'zh_CN'? item.name:item.content" :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item :label="$t('public.mode')" prop="mode">
                <el-select style="width:250px" v-model="dioForm.mode">
                    <el-option :label="$t('asset.mode.' + item.content)" :value="parseInt(item.code)"
                     :key="parseInt(item.code)" v-for="item in modeList"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('public.type')" prop="carrierTypeName">
                <span>{{ dioForm.carrierTypeName }}</span>
            </el-form-item>
            <el-form-item :label="$t('business.traceable')" prop="isTrace">
                <el-checkbox v-model="dioForm.isTrace" :true-label="1" :false-label="0"></el-checkbox>
            </el-form-item>
            <!--<el-form-item :label="$t('device.alarm_on')" prop="alarmSwitch">-->
            <!--    &lt;!&ndash; <el-checkbox v-model="dioForm.alarmSwitch" :true-label="1" :false-label="0"></el-checkbox> &ndash;&gt;-->
            <!--    <el-tag class="icon-margin" closable v-for="(trigger, index) in triggerList" :key="trigger.id" effect="dark"-->
            <!--        @close="closeTag(index)">{{ trigger.name }}</el-tag>-->
            <!--    <i class="el-icon-setting cursor-pointer" @click="selectTrigger"></i>-->
            <!--</el-form-item>-->
            <el-form-item :label="$t('business.tag')" prop="tag">
                <el-input v-model.trim="dioForm.tag" style="width: 250px"></el-input>
            </el-form-item>
            <el-form-item :label="$t('public.table_desc')" prop="description">
                <el-input v-model.trim="dioForm.description" style="width: 250px" type="textarea" maxlength="250"
                    :autosize="{ minRows: 2, maxRows: 4 }" show-word-limit :placeholder="$t('public.please_enter')" />
            </el-form-item>
        </el-form>

        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave" :loading="btnLoading">{{ $t('public.btn_confirm') }}</el-button>
        </div>
        <AlarmSetting :show.sync="alarmShow" :scene="dioForm.sceneId" @confirm="triggerSelect" :triggerList="triggerList">
        </AlarmSetting>
    </modal>
</template>

<script>
import AlarmSetting from '@/components/AlarmSetting/AlarmSetting.vue';
import { carrierNew } from '@/api/modules/carrier.js';
import {shareParam} from "@/api/modules/public";
import { getLanguage } from '@/lang';

export default {
    props: ['title', 'isShow', 'getCarrierType', 'getCarrierStatus'],
    watch: {
        getCarrierType(newVal) {
            // let JsonI18n = JSON.parse(newVal.i18n)
            this.dioForm.carrierTypeName = this.$t('carrier.' + newVal.code);
        }
    },
    components: {
        AlarmSetting
    },
    computed: {
        isShowDialog: {
            get: function () {
                return this.isShow;
            },
            set: function (val) {
                // 隐藏时清空报警列表  清除架构
                if (!val) {
                    this.triggerList = [];
                    this.dioForm.sceneId = null;
                }
                this.$emit('update:isShow', val); //可以优化成model  或者minx
            }
        },
        /** 用于表示当前登录用户属于什么类型的角色 */
        isSysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            return (currentUser.sysScope && currentUser.sysAdmin) || (currentUser.sysScope && !currentUser.sysAdmin);
        },
        rules() {
            let checkDH = (rules, value, cb) => {
                let reg = /^(?!.*-)[^，]*$/;
                if (!reg.test(value)) cb($t('integration.chinese_comma_and_center_line_cannot_be_entered'));
                cb();
            };
            return {
                structureText: [
                    {
                        required: true,
                        message: this.$t('messageTitle.ContentNotEmpty'),
                        trigger: 'change'
                    }
                ],
                status: [{ required: true, message: $t('integration.mount_status_cannot_be_empty'), trigger: 'change' }],
                keycode: [
                    { required: true, message: $t('integration.mount_name_cannot_be_empty'), trigger: 'blur' },
                    {
                        max: 50,
                        message: $t('integration.the_length_of_monitoring_point_is_within_50'),
                        trigger: 'blur'
                    },
                    {
                        trigger: ['blur', 'change'],
                        validator: checkDH
                    }
                ],
                tag: [
                    {
                        max: 50,
                        message: $t('integration.the_length_of_monitoring_point_is_within_50'),
                        trigger: 'blur',
                        required: false
                    }
                ],
                description: [
                    {
                        max: 250,
                        message: $t('integration.the_length_of_monitoring_point_is_within_250'),
                        trigger: 'blur',
                        required: false
                    }
                ],
                mode: [
                    {
                        message: $t('integration.monitoring_point_mode_must_be_selected'),
                        trigger: 'blur',
                        required: true
                    }
                ]
            };
        },
        dataTree() {
            return this.$store.getters.SchemaTree.filter(item => {
                return item.sceneCode !== 'all_node';
            });
        }
    },
    data() {
        return {
            alarmShow: false,
            triggerList: [],
            triggersSelect: [],
            btnLoading: false,
            dioForm: {
                sceneId: null,
                scopeText: null,
                structureText: null,
                structureId: null,
                keycode: null,
                carrierTypeName: null,
                status: null,
                isTrace: 1,
                tag: null,
                alarmSwitch: 1,
                description: null,
                alarmTriggerCarrierList: [],
                mode:null
            },
            modeList:[],
            getLanguage
        };
    },
    methods: {
        // 选择触发器
        selectTrigger() {
            if (!this.dioForm.sceneId) return this.$message.warning($t('integration.please_select_a_schema_first'));
            this.triggersSelect = [...this.triggerList];
            this.alarmShow = true;
        },
        clearValidate() {
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        async justify() {
            try {
                return await this.$refs['form'].validate();
            } catch (error) {
                return false;
            }
        },
        async handleSave() {
            let flag = await this.justify();
            if (!flag) return;
            this.btnLoading = true;
            this.dioForm.alarmTriggerCarrierList = this.triggerList.map(item => {
                return { alarmTriggerId: item.alarmTriggerId };
            });
            if (this.dioForm.alarmTriggerCarrierList.length) {
                this.dioForm.alarmSwitch = 1;
            } else {
                this.dioForm.alarmSwitch = 0;
            }
            let query = { ...this.dioForm };
            delete query.scopeText;
            delete query.structureText;
            delete query.carrierTypeName;
            carrierNew(query, this.getCarrierType['id']).then(async ({ result, state }) => {
                if (result === 200) {
                    await this.$resultHandle(state);
                    this.isShowDialog = false;
                    this.$parent.getListFns();
                } else if (result === 411) {
                    this.$message.error($t('integration.the_same_mount_name_exists'));
                } else if (result === 412) {
                    this.$message.error($t('integration.the_range_of_the_user_is_inconsistent_with_the_current_page_range'));
                } else if (result === 412) {
                    this.$message.error($t('integration.the_range_of_the_user_is_inconsistent_with_the_current_page_range'));
                } else {
                    this.$message.error(state.msg);
                }
            }).finally(() => {
                this.btnLoading = false;
            })
        },
        nodeClick({ label }) {
            if (label.level === 0) return this.$message.warning(this.$t('messageTitle.SelectTheNodeUnderTheRange'));
            this.dioForm.sceneId = label.scopeId;
            this.dioForm.structureId = label.sceneId;
            this.dataTree.forEach(item => {
                if (item['scopeId'] === label.scopeId) {
                    this.dioForm.structureText = item.label + '-' + label.label;
                    this.dioForm.scopeText = item.label;
                }
            });
        },
        triggerSelect(trigger) {
            this.triggerList = trigger;
            this.alarmShow = false;
        },
        closeTag(index) {
            this.triggerList.splice(index, 1);
        },
        getModeList(){
            shareParam({
                type:0,
                code:'carrier_mode'
            }).then(({result})=>{
                this.modeList = result;
            })
        }
    },
    mounted(){
        this.getModeList();
    }
};
</script>

<style lang="scss" scoped>
.treeClass {
    width: 100%;
    height: 100%;
    overflow: auto;

    .el-tree {
        height: 100%;
    }
}

::v-deep .el-textarea__inner {
    border-radius: 2px;
    margin-left: 5px;
}
</style>
